export default __webpack_public_path__ + "static/media/KumbhSans-Bold.4026f7b9.ttf";